import { defineMessages } from 'react-intl';

export default defineMessages({
    notApplicable: {
        id: 'EAPolicyLevelCoveragesComponent.component.Not applicable',
        defaultMessage: 'Not applicable'
    }
});
